import { SizedIconWithCircle } from '@/components/shared/components/SizedIconWithCircle';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { getIconByMerchantVertical } from '@/utils/getIconByMerchantVertical';
import { getMerchantVerticalByMerchantCategory } from '@/utils/getMerchantVerticalByMerchantCategory';

export const businessTypeFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.2,
    disableOnRowClick: true,
    field: 'orderType',
    sortable: false,
    headerName: <Text tId={'SECTOR'} />,
    renderCell: (rowData) => {
      return (
        <SizedIconWithCircle
          variant={'medium'}
          backgroundColor={'none'}
          iconColor={palette.grey[500]}
          customBorderRadius={customBorderRadius.button}
          iconName={getIconByMerchantVertical(
            getMerchantVerticalByMerchantCategory(rowData.row.registrationFields.category),
          )}
          copyToClipboard={{ value: rowData.row.id, textId: 'COPY_MERCHANT_ID' }}
        />
      );
    },
  };
};
